<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Processo para cadastro de um equipamento</h1>
        <paragrafo
          >Aqui estarão listados os equipamentos cadastrados. Para a inclusão de
          um novo, clique em <negrito>Novo Equipamento</negrito> e
          preencha:</paragrafo
        >
        <paragrafo>
          <li>Tipo de equipamento: POS ou QR Code;</li>
          <li>Status: Ativo ou inativo;</li>
          <li>
            Descrição: Algo que identifique facilmente o equipamento (Ex:
            POS-Nome da loja).
          </li></paragrafo
        >
        <imagem :src="image_1" />
        <paragrafo
          >No item POS, preencha corretamente os campos obrigatórios,
          principalmente o Número de Série do equipamento.</paragrafo
        >
        <paragrafo
          >A opção em evidência abaixo deve ser selecionada caso a taxa de
          conveniência ou a comissão devam ser calculadas</paragrafo
        >
        <imagem :src="image_2" />
        <paragrafo
          >No item QR Code, atente-se as opções link de vendas, onde é possível
          gerar um link, gerar um código QR ou copiar este código. Além disso, é
          possível deixá-lo ou não disponível no aplicativo do ponto de
          venda</paragrafo
        >
        <imagem :src="image_3" />
        <paragrafo
          >O link e o código ficam disponíveis ao acessar o ícone
          <negrito>Link de vendas</negrito> no aplicativo do Ponto de Venda. Há
          a opção de cópia ou download do QR Code (veja o material sobre o app
          em Central de Ajuda > POS Admin > Geral)</paragrafo
        >
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Equipamentos",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/imagensAdmin/Operações/operacoes3.png",
      image_2: "/imagensAdmin/Operações/operacoes4.png",
      image_3: "/imagensAdmin/Operações/operacoes5.png",
    };
  },
};
</script>
